import { axiosInstance } from "../../utils/axios";
import { Template } from "../../components/interfaces/Template";

export function getTemplates(): Promise<Template[]> {
  return axiosInstance.get(`/templates`).then((resp) => resp.data);
}
